export function normalizeBranchNumbers(values: string[], maximum = 18): string[] {
  return [...new Set(values.map((value) => value.trim()).filter((value) => /^\d{2}$/.test(value)))]
    .sort((left, right) => left.localeCompare(right))
    .slice(0, maximum);
}

export function toggleBranchNumber(values: string[], branch: string): string[] {
  const normalized = normalizeBranchNumbers(values);
  return normalized.includes(branch)
    ? normalized.filter((value) => value !== branch)
    : normalizeBranchNumbers([...normalized, branch]);
}

export function sameBranchNumbers(left: string[], right: string[]): boolean {
  const first = normalizeBranchNumbers(left);
  const second = normalizeBranchNumbers(right);
  return first.length === second.length && first.every((value, index) => value === second[index]);
}

export function appendBranchParameters(params: URLSearchParams, branches: string[]): void {
  normalizeBranchNumbers(branches).forEach((branch) => params.append("branch", branch));
}
